import React from 'react'
import MappingTabs from './MappingTabs'

const Hotels24Tab = () => <MappingTabs />

export default Hotels24Tab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/Hotels24Tab.js